// import React, { useState, useEffect } from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
// } from "react-router-dom";
// import Login from "./pages/Login";
// import Dashboard from "./pages/admin/Dashboard";
// import Materials from "./pages/admin/Materials";
// import StockUpdate from "./pages/admin/StockUpdate";
// import AddOperator from "./pages/admin/AddOperator";
// import AddClient from "./pages/admin/AddClient";
// import Reports from "./pages/admin/Reports"; // Import Reports component
// import OperatorHome from "./pages/operator/Home";
// import "./styles/common.css";

// function App() {
//   const [user, setUser] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     // Check for stored user on component mount
//     const storedUser = localStorage.getItem("user");
//     if (storedUser) {
//       setUser(JSON.parse(storedUser));
//     }
//     setIsLoading(false);
//   }, []); // Empty dependency array - runs only once on mount

//   const handleLogin = (userData) => {
//     setUser(userData);
//     localStorage.setItem("user", JSON.stringify(userData));
//   };

//   const handleLogout = () => {
//     setUser(null);
//     localStorage.removeItem("user");
//   };

//   // Show loading while checking authentication
//   if (isLoading) {
//     return <div className="loading">Loading...</div>;
//   }

//   return (
//     <Router>
//       <div className="App">
//         <Routes>
//           <Route
//             path="/login"
//             element={<Login user={user} onLogin={handleLogin} />}
//           />

//           {/* Admin Routes */}
//           <Route
//             path="/admin/dashboard"
//             element={
//               user && user.role === "admin" ? (
//                 <Dashboard user={user} onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/login" replace />
//               )
//             }
//           />
//           <Route
//             path="/admin/materials"
//             element={
//               user && user.role === "admin" ? (
//                 <Materials user={user} onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/login" replace />
//               )
//             }
//           />
//           <Route
//             path="/admin/stock-update"
//             element={
//               user && user.role === "admin" ? (
//                 <StockUpdate user={user} onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/login" replace />
//               )
//             }
//           />
//           <Route
//             path="/admin/add-operator"
//             element={
//               user && user.role === "admin" ? (
//                 <AddOperator user={user} onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/login" replace />
//               )
//             }
//           />
//           <Route
//             path="/admin/add-client"
//             element={
//               user && user.role === "admin" ? (
//                 <AddClient user={user} onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/login" replace />
//               )
//             }
//           />
//           {/* New Reports Route */}
//           <Route
//             path="/admin/reports"
//             element={
//               user && user.role === "admin" ? (
//                 <Reports user={user} onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/login" replace />
//               )
//             }
//           />

//           {/* Operator Route */}
//           <Route
//             path="/operator/home"
//             element={
//               user && user.role === "operator" ? (
//                 <OperatorHome user={user} onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/login" replace />
//               )
//             }
//           />

//           <Route path="/" element={<Navigate to="/login" replace />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;
import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ModalProvider } from "./context/ModalContext";
import Login from "./pages/Login";
import "./styles/common.css";

// Code-split the heavy pages: each becomes its own chunk loaded on demand, so
// the initial download is just the login + shell instead of every screen.
// PARKED — screens to be implemented later. The page files and their SQL
// functions are all still in the repo; re-enable by uncommenting these imports,
// the routes below, and the matching links in components/Sidebar.js.
// Admin Home additionally needs Login.js pointed back at "/admin/home".
// const AdminHome = lazy(() => import("./pages/admin/Home"));
// const Dashboard = lazy(() => import("./pages/admin/Dashboard"));
// const Materials = lazy(() => import("./pages/admin/Materials"));
// const StockUpdate = lazy(() => import("./pages/admin/StockUpdate"));

const AddOperator = lazy(() => import("./pages/admin/AddOperator"));
const AddClient = lazy(() => import("./pages/admin/AddClient"));
const Reports = lazy(() => import("./pages/admin/Reports"));
const Notifications = lazy(() => import("./pages/admin/Notifications"));
const OperatorHome = lazy(() => import("./pages/operator/Home"));

function AppContent() {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading…</p>
        </div>
      }
    >
    <Routes>
      <Route path="/login" element={<Login />} />

      {/* Admin Routes */}

      {/* PARKED — screens to be implemented later (see the commented imports above).
      <Route
        path="/admin/home"
        element={
          user && user.role === "admin" ? (
            <AdminHome user={user} onLogout={logout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/admin/dashboard"
        element={
          user && user.role === "admin" ? (
            <Dashboard user={user} onLogout={logout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/admin/materials"
        element={
          user && user.role === "admin" ? (
            <Materials user={user} onLogout={logout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/admin/stock-update"
        element={
          user && user.role === "admin" ? (
            <StockUpdate user={user} onLogout={logout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      */}

      <Route
        path="/admin/add-operator"
        element={
          user && user.role === "admin" ? (
            <AddOperator user={user} onLogout={logout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/admin/add-client"
        element={
          user && user.role === "admin" ? (
            <AddClient user={user} onLogout={logout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/admin/reports"
        element={
          user && user.role === "admin" ? (
            <Reports user={user} onLogout={logout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/admin/notifications"
        element={
          user && user.role === "admin" ? (
            <Notifications user={user} onLogout={logout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Operator Route */}
      <Route
        path="/operator/home"
        element={
          user && user.role === "operator" ? (
            <OperatorHome user={user} onLogout={logout} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Unknown routes fall back to login (which redirects logged-in users). */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <ModalProvider>
          <AppContent />
        </ModalProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;